__webpack_require__.hmrF = () => ("Futures." + __webpack_require__.h() + ".hot-update.json");